import React, { createContext } from 'react';

export const Context = createContext();
